import { Group, Paper, Space, Stack, Stepper, Text } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TaskError } from '@/components/Create_V2/components/Documents/useTaskDocument';
import { StepComponentType } from '@/types/step';

import StepComponent from './StepComponent';

interface Props {
  step: number; // current step index in task list
  failStep?: number; // failed step
  totalSteps: string[]; // task list
  errors?: TaskError[]; // errors
}

export default ({ errors, failStep, step, totalSteps }: Props) => {
  const { t } = useTranslation();

  const StepperStep = useMemo(() => {
    const loadingStep = step + 1;

    return totalSteps.map((text, index) => {
      const stepIndex = index + 1;

      let type: StepComponentType = 'normal';

      // success
      if (stepIndex <= step) type = 'success';
      // loading
      if (!failStep && stepIndex === loadingStep) type = 'loading';
      // failed
      if (stepIndex === failStep) type = 'failed';

      return StepComponent({ type, text, index });
    });
  }, [failStep, step, totalSteps]);

  return (
    <Stack>
      <h3 className="gray.8 font-medium">{t('create_v2.task_list')}</h3>
      <Paper className="p-5 pt-12" shadow="md" radius="lg">
        <Stepper size="sm" active={step} orientation="vertical">
          {StepperStep.map((item) => {
            return item;
          })}
        </Stepper>
        {errors && errors.length > 0 && (
          <Space className="text-xs">
            {errors.map((error, index) => {
              return (
                <Group key={error.id} justify="space-between" wrap="nowrap">
                  <span className="text-ellipsis overflow-hidden">{error.fileName}</span>
                  <Text className="text-xs" color="red.5">
                    {error.message}
                  </Text>
                </Group>
              );
            })}
          </Space>
        )}
      </Paper>
    </Stack>
  );
};
